import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about section">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title">Overview: Built for Resilience and Quality</h2>
          <p className="section-subtitle">
            MAHARAJA POLYFAB LIMITED - Forging the Future of Flexible Packaging in India
          </p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <div className="about-card">
              <h3>Vision & Goal</h3>
              <p>
                Our vision is to bring revolutionary change in the packaging industry by enhancing the value, 
                life and brand of customer's products with better packaging options. We aim to serve the 
                domestic and global markets with our quality products.
              </p>
              
              <h3>History & Focus</h3>
              <p>
                Established in January 2021, we rapidly expanded from an initial 4,250 MT capacity to an
                6,800 MT capacity facility in Odisha. We operate on a Business-to-Business (B2B) model, 
                focusing on customized solutions from 10 Kg up to 100 Kg bags.
              </p>
              
              <h3>Geographic Footprint</h3>
              <p>
                Headquartered in Bargarh, Odisha, we have successfully expanded our market reach beyond our 
                home state to serve key clients in Chhattisgarh, Andhra Pradesh, Maharashtra, West Bengal, 
                and Bihar.
              </p>
              
              <h3>Quality & Certification</h3>
              <p>
                Our manufacturing is supported by in-house quality labs and rigorous compliance, adhering to 
                ISO 9845-1998-RA-2020 (Food Safety Management Systems) and 10910-1984 (Quality Management Systems) 
                standards.
              </p>
              <a href="#company-profile" className="btn btn-primary">Read More</a>
            </div>
          </div>

          <div className="about-features">
            <div className="feature-grid">
              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-globe"></i>
                </div>
                <h4>PP Woven Products</h4>
                <p>
                  We manufacture PP woven sacks and bags that are considered to be the toughest packaging 
                  bags, widely used for Cement, grain, milling, sugar industry, fodder, chemical, and 
                  fertilizer industry.
                </p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-industry"></i>
                </div>
                <h4>Manufacturing Excellence</h4>
                <p>
                  Our 40,000 sq. ft. manufacturing unit in Chakarkend, Bargarh, Odisha has a capacity 
                  to produce about 6800 MT of woven bags per annum with high quality flexographic printing.
                </p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-certificate"></i>
                </div>
                <h4>Quality Features</h4>
                <p>
                  Our products feature flexible and high strength, two side print, heat cut & hemmed top, 
                  flat or anti-slip weaving, and printing up to 4 colors with corona treatment.
                </p>
              </div>

              <div className="feature-item">
                <div className="feature-icon">
                  <i className="fas fa-users"></i>
                </div>
                <h4>Promoters</h4>
                <p>
                  <strong>Mr. Ganesh Sharma</strong><br/>
                  <strong>Mr. Deepak Sharma</strong><br/> 
                  <strong>Mr. Rohit Sharma</strong><br/>
                  <strong>Mr. Puran Mal Sharma</strong><br/>
                  Experienced entrepreneurs leading the company with professional expertise.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="about-stats">
          <div className="stats-container">
            <div className="stat-item">
              <div className="stat-icon">
                <i className="fas fa-boxes"></i>
              </div>
              <div className="stat-content">
                <div className="stat-number">6,800 MT</div>
                <div className="stat-label">Installed Capacity (Volume)</div>
              </div>
            </div>

            <div className="stat-item">
              <div className="stat-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <div className="stat-content">
                <div className="stat-number">7,600 MT</div>
                <div className="stat-label">Average Production (Volume)</div>
              </div>
            </div>

            <div className="stat-item">
              <div className="stat-icon">
                <i className="fas fa-percentage"></i>
              </div>
              <div className="stat-content">
                <div className="stat-number">95.0%</div>
                <div className="stat-label">Average Capacity Utilisation</div>
              </div>
            </div>

            <div className="stat-item">
              <div className="stat-icon">
                <i className="fas fa-user-friends"></i>
              </div>
              <div className="stat-content">
                <div className="stat-number">170+</div>
                <div className="stat-label">Permanent Employees</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
